import DOMPurify from 'dompurify'

const onReady = function () {
  $('.collapse.readmore').on('show.bs.collapse', (e) => {
    const id = DOMPurify.sanitize($(e.currentTarget).attr('id'));
    $(`[data-target="#${id}"]`).text('Show Less');
  });

  $('.collapse.readmore').on('hide.bs.collapse', (e) => {
    const id = DOMPurify.sanitize($(e.currentTarget).attr('id'));
    $(`[data-target="#${id}"]`).text('Show More');
  });
};
$(onReady);
